import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { watermarkOverrideSelector } from 'redux/modules/display-pref/selectors';
import {
  projectTypeByAssets,
  slidesSelector,
  watermarkLockStateSelector,
  watermarkSelector,
  watermarkStatusSelector,
} from 'redux/modules/embed/selectors';
import { State } from 'redux/types';
import { PropsOf } from 'types';
import { getValue } from 'utils/collections';
import { findSlideContainingMillis } from 'utils/embed/slideshow';
import WatermarkTile, { WatermarkTileProps as Props } from './WatermarkTile';

type StateProps = Pick<
  Props,
  | 'hasOverrides'
  | 'imageAtPosition'
  | 'lockState'
  | 'logoImage'
  | 'logoStatus'
  | 'projectType'
>;

const logoSelector = createSelector(
  watermarkSelector,
  (watermark: Map<string, any>): string => watermark && watermark.get('src'),
);

interface OwnProps {
  positionSec?: number;
}

const positionMillisSelector = (__, { positionSec }: OwnProps) =>
  positionSec * 1000;

const backgroundImageSelector = createSelector(
  [positionMillisSelector, slidesSelector],
  (positionMillis, slides) =>
    getValue(findSlideContainingMillis(positionMillis, slides), 'imageUrl'),
);

const mapStateToProps = (state: State, props: OwnProps): StateProps => ({
  hasOverrides: !!watermarkOverrideSelector(state)?.length,
  imageAtPosition: backgroundImageSelector(state, props),
  lockState: watermarkLockStateSelector(state),
  logoImage: logoSelector(state),
  logoStatus: watermarkStatusSelector(state),
  projectType: projectTypeByAssets(state),
});

const component = connect(mapStateToProps)(WatermarkTile);
export type WatermarkTileProps = PropsOf<typeof component>;
export default component;
